import React from "react";

const FeatureTabHeader = ({ currentTab, setCurrentTab, cruise_id }) => {
  const featureTabs = [
    { name: "View Reservations" },
    { name: "Enhance Sailing" },
    { name: "Upgrade Staterooms" },
    {
      name: "Prepare to Sail",
      link: {
        61: "https://margaritavilleatsea.com/resort-at-sea/arrival-embarkation",
        77: "https://margaritavilleatsea.com/resort-at-sea/port-of-tampa",
      },
    },
    // { name: "FAQs" },
  ];
  return (
    <>
      <div className="bg-mv-lightblue hidden md:block">
        <div className="flex py-6 justify-around">
          {featureTabs.map((tab, index) => (
            <div
              onClick={() => {
                window.history.pushState("", "", window.location.pathname);
                if (tab.link)
                  window.open(
                    tab.link[cruise_id],
                    "_blank",
                    "noopener,noreferrer"
                  );
                else setCurrentTab(tab.name);
              }}
              key={index}
              className={`cursor-pointer text-dark-blue text-2xl text-mv-darkblue font-brandon text-24px leading-140 uppercase ${
                currentTab === tab.name ? "font-bold underline" : ""
              } p-4 rounded-lg`}
            >
              {tab.name}
            </div>
          ))}
        </div>
      </div>
      <div>
        <img
          src={`${process.env.PUBLIC_URL}/assets/home/FeatureTabsHeader-bg.png`}
          alt="timer-bg"
          className="w-full"
        />
      </div>
    </>
  );
};

export default FeatureTabHeader;
